import React, { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import useApi from "../../../../hooks/useApi";
import { useAuth } from "../../../../hooks/useAuth";
import { deleteRestaurant } from "../../../../services/restaurantService";
import Alert from "../../../utils/Alert";
import Button from "../../../buttons/Button";
import { stopControllingRestaurant } from "../../../../redux/slices/adminSlice";
import { useDispatch } from "react-redux";
import useLangNavigate from "../../../../hooks/useLangNavigate";

const DangerZone = ({ tKey = "dashboard.settings.dangerZone." }) => {
  const { t } = useTranslation();
  const [hasToConfirmClose, setHasToConfirmClose] = useState(false);
  const { logout } = useAuth();
  const dispatch = useDispatch();
  const { request: deleteRestaurantRequest } = useApi(deleteRestaurant);
  const user = useSelector((state) => state.user);
  const { isOffoodAdmin } = useAuth();
  const controlledRestaurantId = useSelector(
    (state) => state.admin.controlledRestaurantId
  );
  const navigate = useLangNavigate();

  const handleCloseRestaurantAndAccount = useCallback(async () => {
    const restaurantId = controlledRestaurantId || user.restaurantId;
    await deleteRestaurantRequest(restaurantId)
      .then(() => {
        if (!isOffoodAdmin) {
          logout();
        } else {
          dispatch(stopControllingRestaurant());
          navigate("/dashboard");
        }
        toast.success(t(`${tKey}restaurantDeletion.success`));
      })
      .catch((error) => {
        toast.error(t(`${tKey}restaurantDeletion.error`));
        console.log(error);
      });
  }, [
    controlledRestaurantId,
    user.restaurantId,
    deleteRestaurantRequest,
    isOffoodAdmin,
    logout,
    dispatch,
    navigate,
    t,
    tKey,
  ]);

  return (
    <div className="dashboard-content flex column gap-2">
      <div>
        <Alert variant="danger">
          <h4 className="my-2">
            <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
            {t(`${tKey}restaurantDeletion.alert.title`)}
          </h4>
          <p>{t(`${tKey}restaurantDeletion.alert.text`)}</p>
          <Button
            variant={hasToConfirmClose ? "secondary" : "danger"}
            size="sm"
            className="mt-2"
            onClick={() => setHasToConfirmClose(!hasToConfirmClose)}
          >
            {t(
              hasToConfirmClose
                ? `utils.common.cancel`
                : `${tKey}restaurantDeletion.button`
            )}
          </Button>
          {hasToConfirmClose && (
            <Button
              size="sm"
              className="mt-2"
              onClick={handleCloseRestaurantAndAccount}
            >
              {t(`${tKey}restaurantDeletion.lastButton`)}
            </Button>
          )}
        </Alert>
      </div>
    </div>
  );
};

export default DangerZone;
